import { gql } from '../../generated'

export const FETCH_COMPANY_PHONE_SETTINGS = gql(/* GraphQL */ `
  query FetchCompanyPhoneSettings($companyGuid: uuid!) {
    integratedPhoneCompanyConfig(
      where: { companyGuid: { _eq: $companyGuid } }
    ) {
      integratedPhoneEnabled
      integratedVoiceCallingEnabled
      company {
        integratedPhones {
          phoneNumber
          phoneProvider
          companyLeadSource {
            canonicalLeadSourceName
            canonicalLeadSourceNameOverride
          }
          primaryOutboundSms
        }
      }
    }
  }
`)
